"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgArrowRight = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("g", { clipPath: "url(#arrow-right_svg__clip0)" },
            react_1.default.createElement("path", { fill: "currentColor", d: "M14.906 2.04l8.531 8.53c.797.797.797 2.063 0 2.813l-8.53 8.578c-1.079 1.078-2.86 1.078-3.985 0-1.078-1.078-1.078-2.86 0-3.984l3-3.047H2.953A2.94 2.94 0 010 11.977a2.94 2.94 0 012.953-2.954H13.97l-3-3.046a2.801 2.801 0 010-3.938c1.031-1.078 2.86-1.078 3.937 0z" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "arrow-right_svg__clip0" },
                react_1.default.createElement("path", { fill: "currentColor", d: "M0 0h24v24H0z" })))));
};
exports.default = SvgArrowRight;
//# sourceMappingURL=ArrowRight.js.map